<div class="container mt-4">
	<div class="d-flex justify-content-between align-items-center mb-4">
		<h1>Vendas</h1>
	</div>
	<hr />

	<div class="mb-3">
		<div class="input-group">
			<input type="text" class="form-control" placeholder="Pesquisar por nome do cliente ou ID da venda..." [(ngModel)]="searchTerm" (keyup.enter)="search()">
			<button class="btn btn-outline-secondary" type="button" (click)="search()">Pesquisar</button>
			<button class="btn btn-outline-secondary" type="button" (click)="limparBusca()" [disabled]="!searchTerm">Limpar</button>
		</div>
	</div>

	<div class="table-responsive">
		<table class="table table-striped table-hover">
			<thead class="thead-dark">
				<tr>
					<th scope="col">ID</th>
					<th scope="col" class="text-center">Orçamento</th>
					<th scope="col">Cliente</th>
					<th scope="col" class="text-center">Data da Venda</th>
					<th scope="col" class="text-center">Total</th>
					<th scope="col">Pagamento</th>
					<th scope="col" class="text-center">Status</th>
					<th scope="col" class="text-center">Ação</th>
				</tr>
			</thead>

			<tbody>
				<tr *ngFor="let venda of filteredVendas">
					<th scope="row">{{ venda.id }}</th>
					<td class="text-center">{{ venda.idOrcamento }}</td>
					<td>{{ venda.nomeCliente }}</td>
					<td class="text-center">{{ venda.dataVenda | date:'dd/MM/yyyy' }}</td>
					<td class="text-center">{{ venda.totalVenda | currency:'BRL' }}</td>
					<td>{{ venda.formaPagamento }}</td>
					<td class="text-center"> {{ venda.statusVenda }}</td>
					<td class="text-center">
						<button type="button" class="btn btn-info btn-sm me-2" (click)="visualizarVenda(venda)">Visualizar</button>
						<button type="button" class="btn btn-secondary btn-sm me-2" (click)="abrirLogVenda(venda)">Log</button>
						<button type="button" class="btn btn-danger btn-sm me-2" *ngIf="venda.statusVenda !== 'CANCELADO'" (click)="abrirCancelarVenda(venda)">Cancelar</button>
					</td>
				</tr>

				<tr *ngIf="!filteredVendas.length">
					<td colspan="8" class="text-center text-muted py-4">Nenhuma venda encontrada.</td>
				</tr>
			</tbody>
		</table>
	</div>

	<nav *ngIf="totalPages > 1" aria-label="Page navigation" class="pagination-container">
		<ul class="pagination justify-content-center">
			<li class="page-item" [class.disabled]="currentPage === 0">
				<a class="page-link" href="#" (click)="$event.preventDefault(); setPage(0)">Primeira</a>
			</li>
			<li class="page-item" [class.disabled]="currentPage === 0">
				<a class="page-link" href="#" (click)="$event.preventDefault(); setPage(currentPage - 1)">Anterior</a>
			</li>
			<li class="page-item" *ngFor="let page of pages" [class.active]="page === currentPage">
				<a class="page-link" href="#" (click)="$event.preventDefault(); setPage(page)">{{ page + 1 }}</a>
			</li>
			<li class="page-item" [class.disabled]="currentPage >= totalPages - 1">
				<a class="page-link" href="#" (click)="$event.preventDefault(); setPage(currentPage + 1)">Próxima</a>
			</li>
			<li class="page-item" [class.disabled]="currentPage >= totalPages - 1">
				<a class="page-link" href="#" (click)="$event.preventDefault(); setPage(totalPages - 1)">Última</a>
			</li>
		</ul>
	</nav>
</div>

<app-venda-balcao-cupom-modal
	[isOpen]="isVendaBalcaoOpen"
	(closeModal)="closeVendaBalcao($event)">
</app-venda-balcao-cupom-modal>

<app-log-venda-modal
	[isOpen]="isLogVendaOpen"
	[idVenda]="vendaSelecionadaLog?.id ?? null"
	(closed)="fecharLogVenda()">
</app-log-venda-modal>

<app-confirm-dialog
	[isOpen]="isCancelDialogOpen"
	title="Cancelar venda"
	[message]="cancelMessage"
	confirmLabel="Cancelar venda"
	cancelLabel="Voltar"
	[closeOnBackdrop]="!cancelamentoEmAndamento"
	[closeOnEscape]="!cancelamentoEmAndamento"
	(confirmed)="confirmarCancelamento()"
	(cancelled)="fecharCancelarVenda()">

	<div class="cancel-sumario" *ngIf="carregandoSumario">
		<div class="spinner-border spinner-border-sm text-primary" role="status"></div>
		<span>Carregando sumário da venda...</span>
	</div>

	<div class="cancel-sumario" *ngIf="!carregandoSumario && sumarioCancelamento as sumario">
		<h6 class="cancel-sumario__titulo">Sumário da venda</h6>
		<dl class="cancel-sumario__lista">
			<dt>Venda</dt>
			<dd>#{{ sumario.idVenda }}</dd>
			<dt>Cliente</dt>
			<dd>{{ sumario.nomeCliente }}</dd>
			<dt>Data da venda</dt>
			<dd>{{ sumario.dataVenda | date:'dd/MM/yyyy' }}</dd>
			<dt>Total</dt>
			<dd>{{ sumario.totalVenda | currency:'BRL' }}</dd>
			<dt>Orçamento</dt>
			<dd>#{{ sumario.idOrcamento }}</dd>
		</dl>

		<h6 class="cancel-sumario__titulo">Será cancelado em cascata</h6>
		<ul class="cancel-sumario__impacto">
			<li>Orçamento: <strong>{{ sumario.orcamentoSeraCancelado ? 'Sim' : 'Não' }}</strong></li>
			<li>Contas a receber: <strong>{{ sumario.contasAReceberSeraoCanceladas }}</strong></li>
			<li>Movimentos financeiros: <strong>{{ sumario.movimentosFinanceirosSeraoCancelados }}</strong></li>
		</ul>
	</div>
</app-confirm-dialog>
